module.exports = "https://cdn.meeting.tencent.com/assets/events/host/_next/static/images/poster-9-52658b695df34fd18fe93d6eeee7d5f2.jpg";